const getPatientZip = ({ patient, value, billing = false }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  const address = billing ? patient['Billing Address Information'] : patient['Address Information'];
  return address
    ? address['Zip Code']
    : null;
};

export default getPatientZip;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientZip.js